<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderTutorBilling',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'billing', text: 'Billing & Payments', to: AppRoute.BillingTutorInfo, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
